const MILLISECONDS_IN_ONE_MINUTE = 60 * 1000;

/**
 * We are tracking certain events only once for a certain time period.
 * This is block time in milliseconds.
 */
const mixpanelTrackingBlockTime = 5 * MILLISECONDS_IN_ONE_MINUTE;
const IS_FEATURE_ENABLED = process.env.REACT_APP_FEATURE_FLAG_PLACEORDER_V2 === 'true';

export { IS_FEATURE_ENABLED, mixpanelTrackingBlockTime };
